<template>
    <div class="lead-import-manage">
        <Paper class="lead-import-manage-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box ref="searchBox" :search-key="config.name" :fields="config.searchFields"
                        :showResetBtn="true" @search-change="leadImportList.searchList"
                        />
                </template>
                <template slot="header-button">
                    <lotsButton type="primary" size="mini" title="导入" @click="importFile" icon="el-icon-upload2"
                        v-has="authorityCode.importBtn">
                        <span class="icon iconfont">导入</span>
                    </lotsButton>
                    <report-export v-has="authorityCode.exportBtn" #default="{ submit }" reportCode="LCRM_REPORT_LEAD_INFO_EXPORT">
                        <lotsButton type="primary" size="mini" title="导出" @click="exportFile(submit)" icon="el-icon-download">
                            <span class="icon iconfont">导出</span>
                        </lotsButton>
                    </report-export>
                    <lotsButton type="primary" size="mini" title="生成线索" @click="generateLead()" icon="el-icon-plus"
                        v-has="authorityCode.generateBtn" :disabled="curSelectList.length === 0">
                        <span class="icon iconfont">生成线索</span>
                    </lotsButton>
                    <lotsButton type="primary" size="mini" title="废弃线索" @click="abandonedLead()" v-has="authorityCode.abandonedBtn"
                        icon="el-icon-delete" :disabled="curSelectList.length === 0">
                        <span class="icon iconfont">废弃</span>
                    </lotsButton>
                    <lotsButton type="primary" size="mini" title="刷新" @click="refresh" plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" :title="'列配置'"
                            @click="showColumnConfigDialog" plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box class="prescreen" v-loading="leadImportList.tableLoading" :selection="config.selection"
                        :control="false" :columns="config.columns" :height="tableHeight"
                        :tableData="leadImportList.totalData" :actions="config.actions" :editDisableRule="() => false"
                        :allowRowClick="false" @action-click="actionClick" :rows="leadImportList.totalData"
                        @selection-change="handleSelectedRow">
                        <template #col-header="{ col }">
                            <span class="slot-box"
                                v-if="['contactPhone', 'contactEmail'].includes(col.prop)">
                                <span>
                                    {{ col.label }}
                                </span>
                                <img :class="['text-eyes']" @click.stop="handleChangeText(col)"
                                    :src="encryption[col.prop] ? iconOpenEyes : iconCloseEyes" alt="">
                            </span>
                                <!-- -->

                            <span v-else> {{ col.label }}</span>
                        </template>
                        <template v-slot:col-append="{ col, row }">
                            <div v-if="col.prop === 'customerCode'">
                                <span class="customer-code-text" :title="row.customerCode" @click="goCustomerDetail(row.customerCode)">{{ row.customerCode || '' }}</span>
                            </div>
                            <div v-if="['contactPhone', 'contactEmail'].includes(col.prop)">
                                <span size="mini" type="text" class="mip-page-link no-wrap" :title="row[col.prop]">{{
                                    encryptionHandle(row[col.prop] || '', col.prop)
                                }}</span>

                            </div>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination @size-change="leadImportList.sizeChange"
                        :current-page.sync="leadImportList.pageNo" @current-change="leadImportList.pageChange"
                        size="small" layout="total, sizes, prev, pager, next, jumper"
                        :total="leadImportList.pageTotal" />
                </template>
            </list-layout-paper>
            <column-config :pageID="config.name" :initColumns="config.columns" ref="otpColumnConfig"
                @header-change="config.columns = $event" />
        </Paper>
        <!-- 导入弹窗 -->
        <addFileDialog ref="fileDialogRef" :config="config.importConfig" @uploadSuccessHandle="uploadSuccessHandle"
            @uploadFailHandle="uploadFailHandle">
        </addFileDialog>
    </div>
</template>

<script>
import { ref, reactive, computed, watch, getCurrentInstance, onMounted } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import { tableConfig } from './config.js';
import _ from 'lodash';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getLeadList, getLeadGenerate, getLeadDiscard, getAdminRole } from '@mdm/api/leadManage/leadImport.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { Message, MessageBox } from 'element-ui';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import bigDataLog from '@/utils/bigDataLog.js';
import reportExport from '@/components/lots/reportExportPlugin';
import store from '@/store';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';

export default {
    name: 'leadImportManage',
    components: {
        lotsPagination,
        tableBox,
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        columnConfig,
        addFileDialog,
        reportExport
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = reactive(_.cloneDeep(tableConfig));
        const authorityCode = reactive(btnAuthority.leadImportList);
        const { user } = store.getters;
        class LeadImportListClass extends AdvanceListClass {
            beforeGetList(condition) {
                delete condition.companyName;
                return condition;
            };
            afterGetList(res) {
                if (res && +res.code === 0) {
                    leadImportList.pageTotal.value = res.data.totalCount;
                    leadImportList.totalData.value = res.data.list || [];
                }
            };
        }
        const leadImportList = new LeadImportListClass({
            Api: {
                listApi: getLeadList
            }
        });
        const refresh = () => {
            leadImportList.getList();
        };
        const actionClick = (event, row, index) => {
            // 行操作
            curSelectList.value = [row.id];
            if (event === 'generate') {
                // 生成线索
                generateLead();
            } else if (event === 'abandoned') {
                // 废弃线索
                abandonedLead();
            }
        };
        const isAdminRole = ref(false);
        const getAdminRoleData = () => {
            getAdminRole({ mipCode: user.userCode }).then(res => {
                console.log(res);
                if (res && +res.code === 0) {
                    isAdminRole.value = res.data;
                }
            });
        };
        const curSelectList = ref([]);
        const handleSelectedRow = (selection) => {
            // 选择行
            curSelectList.value = selection.map(it => it.id);
        };
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            // 行配置
            otpColumnConfig.value.show(true);
        };
        const importFile = () => {
            // 导入
            setupContext.refs.fileDialogRef.openImport();
        };
        const uploadSuccessHandle = () => {
            leadImportList.getList();
        };
        const uploadFailHandle = () => {
            leadImportList.getList();
        };
        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => (item.name);
        const exportFile = async(submit) => {
            // 导出
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = leadImportList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns)?.filter(it => it.property !== 'file');
            // 最新格式化导出
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...newData,
                requestResults: excelTitleList.join(','),
                userCode: +isAdminRole.value ? undefined : user.userCode,
                adminRole: +isAdminRole.value,
                'tenantCode': 'annto'
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            submit(params);
        };
        const generateLead = (ids = []) => {
            // 生成线索
            if (curSelectList.value.length === 0) {
                return Message.warning('请选择需要生成线索的数据');
            }
            MessageBox.confirm(`请确认是否生成线索？`, `提示：`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    leadIds: curSelectList.value
                };
                getLeadGenerate(params).then(res => {
                    console.log(res);
                    if (res && +res.code === 0) {
                        Message.success('生成线索成功');
                        leadImportList.searchList();
                    }
                });
            }).catch(() => {
                // leadImportList.searchList();
                console.log('cancel');
            });
        };
        const abandonedLead = (ids = []) => {
            // 废弃线索
            if (curSelectList.value.length === 0) {
                return Message.warning('请选择需要废弃线索的数据');
            }
            MessageBox.confirm(`请确认是否废弃线索？`, `提示：`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    leadIds: curSelectList.value
                };
                getLeadDiscard(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('废弃线索成功');
                        leadImportList.searchList();
                    }
                });
            }).catch(() => {
                // leadImportList.searchList();
                console.log('cancel');
            });
        };
        const goCustomerDetail = (code) => {
            if (code) {
                ctx.$router.push({ path: '/mod/mdm/customer-manage', query: { customerCode: code } });
                bigDataLog.sendDetailMessageByKey('bigData-page-customer-detail');
            }
        };
        const dictDatas = ref({});
        onMounted(async () => {
            dictDatas.value = await otherUtils.getDictDataList(config.columns);
            await getAdminRoleData();
            const queryParams = {
                leadStatusList: []
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        });
        const encryption = ref({
            contactEmail: false,
            contactPhone: false
        });
        const handleChangeText = (item) => {
            encryption.value[item.prop] = !encryption.value[item.prop];
            item.className && bigDataLog.sendDetailMessageByKey(item.className);
        };
        const menuList = {
            contactEmail: 'email',
            contactPhone: 'mobile'
        };
        const encryptionHandle = (val, p) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p]) return val;
            return desensitization[prop](val);
        };
        return {
            config,
            leadImportList,
            authorityCode,
            otpColumnConfig,
            curSelectList,
            iconCloseEyes,
            iconOpenEyes,
            encryption,
            refresh,
            actionClick,
            handleSelectedRow,
            importFile,
            exportFile,
            showColumnConfigDialog,
            generateLead,
            abandonedLead,
            uploadSuccessHandle,
            uploadFailHandle,
            goCustomerDetail,
            encryptionHandle,
            handleChangeText
        };
    }
};
</script>

<style scoped lang="less">
.lead-import-manage {
    width: 100%;

    .lead-import-manage-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .list-main {
        overflow: auto;
        .customer-code-text{
            color: #4285F5;
            cursor: pointer;
        }
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.lead-import-manage-paper {
        padding: 0px 0px 0px;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .text-eyes {
        width: 14px;
        margin-left: 4px;
        cursor: pointer;
        position: relative;
        top: 2px;
    }
    .slot-header-title{
        width: 100%;
        display: inline-block;
    }

}
</style>
